import dayjs from 'dayjs';
import { Message } from 'element-ui';
import { validateSearchTime } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index.js';
import _ from 'lodash';
import { searchFieldSeperated } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/searcher.js';

/// 将日期格式化为 2021-12-02 18:08:23 这样的格式
function formatTime(dateString) {
    return dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
}
/// 日期范围格式化:
///   { [datetimeRangeKey]: [dateBegin, dateEnd] } => { [startKey]: formattedDate, [endKey]: formattedDate }
export function formatDatetimeRange(params, datetimeRangeKey, startKey, endKey) {
    if (Array.isArray(params[datetimeRangeKey]) && params[datetimeRangeKey].length >= 2) {
        params[startKey] = formatTime(params[datetimeRangeKey][0]);
        params[endKey] = formatTime(params[datetimeRangeKey][1]);
    }
    delete params[datetimeRangeKey];
}

/**
 * @description 时间处理
 * @description createTime 创建时间，dispatchTime 发车时间，leaveDate 离园时间
 * @return data 搜索数据
 */
const formatSearchData = data => {
    const params = _.cloneDeep(data);
    const advanceList = ['siteName', 'siteCode', 'whName', 'whCode', 'companyName', 'companyCode', 'customerName', 'customerCode',
        'carrierName', 'carrierCode', 'driver', 'driverContactWay', 'vehicleCard', 'noCarCarrierName', 'noCarCarrierCode'];
    advanceStringToArray(params, advanceList);
    if (params.senderAddress && params.senderAddress.length >= 3) {
        params.senderProvinceCode = params.senderAddress[0] || '';
        params.senderCityCode = params.senderAddress[1] || '';
        params.senderDistrictCode = params.senderAddress[2] || '';
    }
    if (params.receiverAddress && params.receiverAddress.length >= 3) {
        params.receiverProvinceCode = params.receiverAddress[0] || '';
        params.receiverCityCode = params.receiverAddress[1] || '';
        params.receiverDistrictCode = params.receiverAddress[2] || '';
    }
    params.createUserNameDispatchList = searchFieldSeperated(params.createUserNameDispatch || '');
    params.customerOrderNoList = searchFieldSeperated(params.custOrderNo || '');
    params[params.batchQueryKey] = processQueryParams(params.batchQueryKey, params.batchQueryValue);
    formatDatetimeRange(params, 'createTime', 'createTimeStart', 'createTimeEnd');
    formatDatetimeRange(params, 'dispatchTime', 'bcDepartTimeStart', 'bcDepartTimeEnd');
    formatDatetimeRange(params, 'leaveDate', 'leaveDateStart', 'leaveDateEnd');
    formatDatetimeRange(params, 'arrivalTime', 'arrivalTimeStart', 'arrivalTimeEnd');
    formatDatetimeRange(params, 'departPicUploadTime', 'departPicUploadTimeStart', 'departPicUploadTimeEnd');
    formatDatetimeRange(params, 'driverOrderTime', 'driverOrderTimeStart', 'driverOrderTimeEnd');
    delete params.createUserNameDispatch;
    delete params.batchQueryKey;
    delete params.batchQueryValue;
    delete params.custOrderNo;
    delete params.senderAddress;
    delete params.receiverAddress;
    return params;
};

const advanceStringToArray = (data, advanceList) => {
    advanceList.forEach(key => {
        if (data[key]) {
            data[`${key}List`] = data[key] ? data[key].split(',') : [];
        }
        delete data[key];
    });
};

const processQueryParams = (key, value) => {
    const batchQueryKeyArr = ['dispatchNoList', 'taskNoList', 'netDispatchNoList', 'orderNoList', 'dispatchNoMappingList', 'contractNoList'];
    if (batchQueryKeyArr.includes(key)) {
        return searchFieldSeperated(value || '');
    } else {
        return value || '';
    }
};
/**
 * @description 创建时间格式处理
 * @description createTime 创建时间
 * @return data 查询数据
 */
const formatSetSearchTime = data => {
    const searchData = _.cloneDeep(data);
    // 校验时间格式是否为 YYYY-MM-DD HH:mm:ss
    const reg = /^(\d{1,4})\-(\d{1,2})\-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    if (searchData.createTime && !reg.test(searchData.createTime[0])) {
        searchData.createTime[0] = formatTime(searchData.createTime[0]);
        searchData.createTime[1] = formatTime(searchData.createTime[1]);
    }
    delete searchData.batchQueryKey;
    delete searchData.batchQueryValue;
    return searchData;
};

const getDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();
    const end = new Date(year, month, day, 23, 59, 59, 0);
    const start = new Date(year, month, day, 0, 0, 0, 0);
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    return { start, end };
};

/**
 * @description 校验查询条件
 * @param data 查询数据
 * @param maxSearchDay 最大查询区间
 */
const validateSearchData = (data, maxSearchDay = 31, maxNum = 100) => {
    const oddNumbersField = ['dispatchNoList', 'taskNoList', 'netDispatchNoList', 'orderNoList', 'dispatchNoMappingList', 'contractNoList', 'customerOrderNoList'];
    const batchSearchField = ['dispatchNoList', 'taskNoList', 'netDispatchNoList', 'orderNoList', 'dispatchNoMappingList', 'contractNoList', 'customerOrderNoList'];
    if (requiredVerification(data, oddNumbersField) && !data.createTimeStart && !data.bcDepartTimeStart && !data.arrivalTimeStart) {
        Message.warning('单号、创建时间、抵达时间、发车时间 不可同时为空');
        return false;
    }
    if (maxLengthVerification(data, batchSearchField, maxNum)) {
        Message.warning(`按照单号查询，每次最多支持查询${maxNum}单`);
        return false;
    };
    if (data.whNameList && data.whNameList.length) {
        if (!data.siteCodeList || data.siteCodeList.length === 0) {
            Message.warning('以仓库为查询条件时，服务平台必填');
            return false;
        }
    }
    return validateSearchTime(data, 'createTimeStart', 'createTimeEnd', maxSearchDay) &&
        validateSearchTime(data, 'departPicUploadTimeStart', 'departPicUploadTimeEnd', maxSearchDay);
};

const maxLengthVerification = (data, fieldList, maxNum = 100) => {
    return fieldList.some(v => data[v] && data[v].length > maxNum);
};

const requiredVerification = (data, fieldList) => {
    return fieldList.every(v => !(data[v] && data[v].length));
};

// 批量发车校验
const validateIsBatchDepart = data => {
    if (!data.length) {
        Message.warning('请选择发车单');
        return false;
    } else if (data.length > 50) {
        Message.warning('最多只能选择50条数据');
        return false;
    }
    return true;
};

const YES_OR_NO = {
    'Y': '是',
    'N': '否'
};

/**
 * @description 初始化列表数据
 * @description 数字字典间的转换
 * @return tableData 数据列表
 */
const formatTotalDataList = (data, dictData, dictContractLine) => {
    const dictContractLineList = Object.keys(dictContractLine.data.CONTRACT_OUT_LINE);
    if (!data.length) return [];
    data.forEach(item => {
        item.transportProtocolStatusName = dictData.TP_DISPATCH_STATUS[item.transportProtocolStatus];
        item.carrierVisibleFlagName = dictData.CARRIER_VISIBLE_FLAG[item.carrierVisibleFlag];
        item.inOutTypeName = dictData.OTP_IN_OUT_TYPE[item.inOutType];
        item.noCarPlatformFlagName = dictData.OTP_NOCAR_PLATFROM[item.noCarPlatformFlag];
        item.noCarCarrierTypeName = dictData.NO_CAR_CARRIER_TYPE[item.noCarCarrierType];
        item.dmsFlagName = dictData.YES_OR_NO_STRING_POINT[item.dmsFlag];
        item.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel];
        item.dispatchStatusName = dictData.DISPATCH_STATUS[item.dispatchStatus];
        item.iflowStatusName = dictData.NEW_TMS_IFLOW_STATUS[item.iflowStatus];
        item.arriveTypeName = dictData.PICK_UP_TYPE[item.arriveType];
        item.deviceTypeName = dictData.DEVICETYPE[item.deviceType];
        item.payMethodName = dictData.SYS_TMS_PAY_METHOD[item.payMethod];
        item.exceptionTypeName = dictData.EXCEPTION_TYPE[item.exceptionType];
        item.shippingTypeName = dictData.TMS_SHIPPING_TYPE[item.shippingType];
        item.transportTypeName = dictData.EC_TRANSPORT_TYPE[item.transportType];
        item.isIssueName = dictData.IS_ISSUE[item.isIssue];
        item.lclStatusName = dictData.LCL_STATUS[item.lclStatus];
        item.loadTypeName = dictData.NEW_TMS_LOAD_TYPE[item.loadType];
        item.dispatchWayName = dictData.DISPATCH_WAY[item.dispatchWay];
        item.contractOutName = dictData.TMS_CONTRACT_SITUATION[item.contractOut];
        item.driverOrderStatusName = dictData.DRIVER_ORDER_STATUS[item.driverOrderStatus];
        item.currentAlertTypeName = dictData.CURRENT_ALERT_TYPE[item.currentAlertType];
        item.expectedResultName = dictData.EXPECTED_RESULT[item.expectedResult];
        item.isIflowName = item.isIflow === true ? '是' : '否';
        item.bindingDeviceFlagName = +item.bindingDeviceFlag === 0 ? '已绑定' : '未绑定';
        item.otpLdFlagName = item.otpLdFlag === 'Y' ? '是' : '否';
        item.billingAdvanceFlag = item.billingAdvanceFlag + '';
        item.trialCalculateFlag = item.trialCalculateFlag + '';
        item.billingExceptionFlag = item.billingExceptionFlag + '';
        item.pointsNumber = (+item.totalArrivalConfirmSiteNum || 0) + (+item.totalArrivalRegistrationSiteNum || 0) - 1; // 装货站点及卸货站点数的和减1
        item.abnormalDepartReasonName = dictData.ABNORMAL_DEPART_REASON[item.abnormalDepartReason];
        item.departBmsFlagName = YES_OR_NO[item.departBmsFlag] || '';
        item.transportLog = '查看日志';
        item.fullLoadRate = item.fullLoadRate && (Math.round(item.fullLoadRate * 10000) / 100) + '%';
        item.showPhotos = Boolean(item.departPicUrl);
        item.noShowPhotos = Boolean(!item.departPicUrl);
        item.ztbTransportFlag = String(item.ztbTransportFlag);
        item.shippingSceneType = String(item.shippingSceneType);
        item.pickUpStatus = String(item.pickUpStatus);
        item.billingRanksFlag = String(item.billingRanksFlag);
        item.mileageBillingType = String(item.mileageBillingType);
        item.directControlLineFlag = String(item.directControlLineFlag);
        item.directControlCarrierFlag = String(item.directControlCarrierFlag);
        initHiddenBtn(item, dictContractLineList);
    });
    return data;
};

/**
 * @description 初始化操作按钮显隐，并给当前行hiddenEvent字段添加标记
 * @param dispatchStatus(发车单状态, 字典：DISPATCH_STATUS) dispatchStatus： 待确认(0), 待到车(10), 待装车(20), 待发车(30), 在途(40), 待签收(60), 抵达(50), 完成(100)
 * @applyStatus 审批状态 字典：SYS_MIP_IFLOW_STATUS 废弃(00),草稿(10),驳回(11),待审(20),出错(21),通过(30)
 * @return tableData 数据列表
 */
const initHiddenBtn = (item, dictContractLineList) => {
    item.hiddenEvent = [];
    // 在途登记: 发车单状态为“在途”、”抵达“、”待签收“，按钮可用
    if (![40, 50, 60].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('onTheWay');
    }

    // 成本校验、成本审批、合同外线路: 发车单状态为“待到车”、“待装车”、“待发车” 或者 来源系统为‘拉卡拉’且发车单状态为'签收'之前
    if (item.dispatchStatus > 30 && item.dispatchChannel !== 'COSTLKL-WBKH') {
        item.hiddenEvent.push('costValidator', 'costValidatorByCar', 'costApprove', 'contractLine');
    } else if (item.dispatchStatus > 60 && item.dispatchChannel === 'COSTLKL-WBKH') {
        item.hiddenEvent.push('costValidator', 'costValidatorByCar', 'costApprove', 'contractLine');
    }

    if (item.freightBasis !== '40') { // 搬仓订单不隐藏
        // 包含厨热订单时，审批状态为审批通过，并且发起了厨热分摊时隐藏按钮，反之 审批状态为审批通过就隐藏按钮
        if (item.kitchenOrderCount ? ['P'].includes(item.iflowStatus) && item.businessIflowUrl : ['P'].includes(item.iflowStatus)) {
            item.hiddenEvent.push('contractLine');
        }
    }

    // 成本审批、成本校验、运输协议: 发车单的采购渠道为“自调车”
    if (item.procurementChannel !== '00') {
        item.hiddenEvent.push('costValidator', 'costValidatorByCar', 'costApprove', 'transportProtocol');
    }

    // 发车单的采购渠道为“自调车”，且无车平台类型不是“天津网货”, 显示运输协议
    // if (item.procurementChannel === '00' && item.noCarCarrierType === '40') {
    //     item.hiddenEvent.push('transportProtocol');
    // }

    // 运输协议签署状态为“未签署”时，按钮可用
    // if (item.transportProtocolStatus) {
    //     if (item.transportProtocolStatus !== '1') {
    //         item.hiddenEvent.push('transportProtocol');
    //     }
    // }

    // 成本校验: 未发起MIP流程（审核状态为作废），按钮可用
    if (item.iflowLink) {
        if (!['C'].includes(item.iflowStatus)) {
            item.hiddenEvent.push('costValidator', 'costValidatorByCar');
        }
    }

    // 成本审批: zdcFlowFlag(是否需要启动自调车流程)为true，才可以发起MIP成本审批
    if (!item.zdcFlowFlag) {
        item.hiddenEvent.push('costApprove');
    }

    // 合同外线路: 采购渠道为自调车、临时专线、快递公司、信息中介、网络调车平台、零担专线，不能启动合同外线路流程
    if (dictContractLineList.includes(item.procurementChannel)) {
        item.hiddenEvent.push('contractLine');
    }

    // 园区预约: 出库类型为入库订单的时候 隐藏"园区预约"操作按钮
    if (item.inOutType === 'IN') {
        item.hiddenEvent.push('parkAppoint');
    }

    // 到车登记: 城配订单发车单状态为待到车, 或者 基地订单、没有到车登记时间 || 非入库时，展示按钮
    if (![10].includes(+item.dispatchStatus) && item.orderDistinctionFlag === 'CP') {
        item.hiddenEvent.push('arrivalRegistration');
    } else if (item.orderDistinctionFlag !== 'CP' && (item.actualArriveDate || ['IN'].includes(item.inOutType))) {
        item.hiddenEvent.push('arrivalRegistration');
    }

    // 取消到车: 城配订单发车单状态为“待装车”，或者 基地订单存在到车登记时间 || 待发车之前状态，按钮可用
    if (![20].includes(+item.dispatchStatus) && item.orderDistinctionFlag === 'CP') {
        item.hiddenEvent.push('cancelArrival');
    } else if (item.orderDistinctionFlag !== 'CP' && (!item.actualArriveDate || +item.dispatchStatus >= 30)) {
        item.hiddenEvent.push('cancelArrival');
    }

    // 明细装车、整单装车: 发车单状态为"待装车"，按钮可用
    if (![20].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('detailedLoading', 'wholeOrderLoading');
    }

    // 发车: 发车单状态为“待发车”状态，按钮可用
    if (![30].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('depart');
    }

    // 运抵确认: 发车单状态为“在途”、“抵达”、“待签收”，按钮可用
    if (![40, 50, 60].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('arrivalConfirmation', 'cancelShipTo');
    }

    // 取消零担下发: 发车单的下发状态为“已下发”，按钮才可用
    if (item.lclStatus !== '2') {
        item.hiddenEvent.push('cancelIssue');
    }

    // 零担下发: otpLdFlag为Y显示零担下达，为N或空不显示
    if (item.otpLdFlag !== 'Y') {
        item.hiddenEvent.push('issue');
    } else {
        // 零担下发: 发车单的下发状态为“下发失败”、“未下发”，按钮才可用 || 零担下发: 发车单状态为“在途”，按钮可用
        if (!['', 0, 1].includes(+item.lclStatus) || ![40].includes(+item.dispatchStatus)) {
            item.hiddenEvent.push('issue');
        }
    }

    // 取消零担下发: 发车单状态为“在途”，按钮可用
    if (![40].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('cancelIssue');
    }

    // 园区预约: 发车单状态为”完成"之前的状态，按钮可用
    if ([100].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('parkAppoint');
    }

    // 位置信息查看: 发车单状态为“在途”、”抵达“、”待签收“、“已完成”，按钮可用
    if ([0, 10, 20, 30].includes(+item.dispatchStatus)) {
        item.hiddenEvent.push('viewLocationInformation');
    }

    // 装车顺序
    if (+item.dispatchStatus > 30) {
        item.hiddenEvent.push('sequence');
    }

    // 取消装货：cancelLoadFlag标识为true时，按钮可用
    if (item.cancelLoadFlag !== true) {
        item.hiddenEvent.push('cancelLoading');
    }

    // 发车单承运商为快递公司且调用快递服务，即有快递单号的，不允许操作到车，发车，抵达，签收
    if (item.expressNo) {
        item.hiddenEvent.push('arrivalRegistration', 'cancelArrival', 'depart', 'arrivalConfirmation');
    }

    // 任务设备：发运类型为零担，展示按钮。否则隐藏
    // if (+item.shippingType !== 0) {
    //     item.hiddenEvent.push('taskDevice');
    // }

    const completeVehicle = +item.shippingType === 1; // 发运类型为整车
    const inTransit = +item.dispatchStatus === 40; // 发车单状态为在途
    const baseOrder = +item.dispatchType === 6; // 发车单存在基地订单标识
    const procurementChannel = ['20', '40', '120', '171'].includes(item.procurementChannel); // 采购渠道为物流公司、车队供应商、快递公司、零担专线
    // 以上条件全部满足，展示 在途编辑 按钮，有一项不符合，则隐藏
    if (!completeVehicle || !inTransit || !baseOrder || !procurementChannel) {
        item.hiddenEvent.push('inTransitEdit');
    }

    // 模糊发车单禁用相关按钮
    if (+item.planOrderFlag === 2) {
        item.hiddenEvent.push('cancelArrival', 'issue', 'cancelIssue', 'dispatchDevice', 'parkAppoint', 'onTheWay', 'abnormalReason', 'cancelLoading', 'taskDevice');
    }

    // 没有打印记录，即打印次数小于1，则隐藏按钮
    if (!item.allPrintTimes || +item.allPrintTimes < 1) {
        item.hiddenEvent.push('printLog');
    }
};

// 是否无车平台（noCarPlatformFlag）且无车平台类型: 天津网货（noCarCarrierType: NO_CAR_CARRIER_TYPE）
const isNoCarPlatformAndTianjinWangHuo = data => {
    return data.noCarPlatformFlag === 'Y' && +data.noCarCarrierType === 40;
};

/**
 * @description 整车异常发车原因登记校验
 */
const isValidate = data => {
    if (Array.isArray(data)) {
        if (!data.length) {
            Message.warning('请选择发车单');
            return false;
        }
        for (const item of data) {
            if (!validate(item)) return false;
        }
        // 是否在始发地围栏全部 不为否时，弹出提示，不可登记
        const isFence = data.filter(data => data.startAddrFenceFlag === 0);
        if (!isFence.length) {
            Message.warning('是否在始发地围栏为否时才可登记');
            return false;
        }
        return true;
    } else {
        if (!validate(data)) return false;
        if (data.startAddrFenceFlag !== 0) {
            Message.warning('是否在始发地围栏为否时才可登记');
            return false;
        }
        return true;
    }
};

/**
 * @description 选择数据中发运类型存在非整车、发车状态存在未发车，则弹出提示，不可登记
 */
const validate = data => {
    if (+data.shippingType !== 1) {
        Message.warning('发运类型为整车才可登记');
        return false;
    }
    if (![40, 50, 60, 100].includes(+data.dispatchStatus)) {
        Message.warning('发车后才可登记');
        return false;
    }
    return true;
};

const isEditTransport = data => {
    if (data.departBmsFlag !== 'N' || data.procurementChannel !== '00' || +data.dispatchStatus <= 30) {
        Message.warning('发车单已发车且未推BMS计费，才允许编辑');
        return false;
    }
    return true;
};

/**
 * @description 发车重排校验:选择两个及以上发车单，选择所选发车单都为整车发运类型，专司打标为零担干线，排车车牌相同，均为在途状态，否则不进行操作
 */
export const isValidateReset = data => {
    if (data.length < 2) {
        Message.warning('不满足发车重排条件，请检查后重试');
        return false;
    }
    for (const item of data) {
        if (+item.shippingType !== 1 || item.professionalCompany !== '零担' || item.vehicleCard !== data[0].vehicleCard || +item.dispatchStatus !== 40) {
            Message.warning('不满足发车重排条件，请检查后重试');
            return false;
        }
    }
    return true;
};

export const setAllPropertyValuesToNull = obj => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== 'batchQueryKey') {
            obj[key] = null;
        }
    }
};

export { formatSearchData, validateSearchData, formatTotalDataList, isNoCarPlatformAndTianjinWangHuo, validateIsBatchDepart, formatSetSearchTime, isValidate, isEditTransport, getDate };
